import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import InputField from '../../Reusable/InputField';
import KeybordDatePicker from '../../Reusable/KeyboardDatePicker';
import CustomSelect from '../../Reusable/CustomSelect';
import RadioGroupField from '../../Reusable/RadioGroupField';

const SecondSection = (props) => {
  const { onChange, state, onDateChange, errors, errorsHandler } = props || {};

  const originCountryData = [
    {
      id: 1,
      name: 'Srbija',
      value: 'serbia',
    },
    {
      id: 2,
      name: 'Crna Gora',
      value: 'montenegro',
    },
  ];

  const GenderData = [
    {
      id: 1,
      value: 1,
      label: 'Ženski',
    },
    {
      id: 2,
      value: 2,
      label: 'Muški',
    },
  ];

  const residentStatusData = [
    {
      id: 1,
      name: 'Rezident',
      value: 'resident',
    },
    {
      id: 2,
      name: 'Nerezident',
      value: 'notResident',
    },
  ];

  return (
    <Card>
      <Card.Header className="primary-header-card">
        <Card.Title className="d-flex gap-3 align-items-center">
          Opšti podaci
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={4}>
            <KeybordDatePicker
              id="dateOfBirth"
              name="dateOfBirth"
              label={'Datum rođenja/osnivanja'}
              onChange={onDateChange}
              value={state.dateOfBirth}
              placement={'bottom'}
            />
            <InputField
              id="placeOfBirth"
              name="placeOfBirth"
              placeholder={'Mesto rođenja/osnivanja'}
              onChange={onChange}
              value={state.placeOfBirth}
            />
            <KeybordDatePicker
              id="dateOfRegistration"
              name="dateOfRegistration"
              label={'Datum registracije'}
              onChange={onDateChange}
              value={state.dateOfRegistration}
              placement={'bottom'}
            />
            <KeybordDatePicker
              id="dateOfAuthorization"
              name="dateOfAuthorization"
              label={'Datum punomoći'}
              onChange={onDateChange}
              value={state.dateOfAuthorization}
              placement={'bottom'}
            />
            <CustomSelect
              id={'originCountry'}
              name={'originCountry'}
              label={'Zemlja rođenja/osnivanja'}
              data={originCountryData}
              textExtractor={(a) => a?.name}
              valueExtractor={(a) => a?.value}
              value={state.originCountry}
              onChange={onChange}
              required
              error={errors}
              errorsHandler={errorsHandler}
            />
          </Col>
          <Col md={4}>
            <RadioGroupField
              name={'gender'}
              label={'Pol:'}
              data={GenderData}
              value={state.gender}
              onChange={onChange}
              row
              inlineLabel
            />
            <InputField
              id="sortOfAuthor"
              name="sortOfAuthor"
              placeholder={'Vrsta autora'}
              onChange={onChange}
              value={state.sortOfAuthor}
            />
            <InputField
              id="jmbg"
              name="jmbg"
              placeholder={'JMBG'}
              onChange={onChange}
              value={state.jmbg}
            />
            <InputField
              id="passportNumber"
              name="passportNumber"
              placeholder={'Broj pasoša'}
              onChange={onChange}
              value={state.passportNumber}
              type={'number'}
            />
            <KeybordDatePicker
              id="dateOfDeath"
              name="dateOfDeath"
              label={'Datum smrti/gašenja'}
              onChange={onDateChange}
              value={state.dateOfDeath}
              placement={'bottom'}
            />
          </Col>
          <Col md={4}>
            <KeybordDatePicker
              id="dateOfContractMP"
              name="dateOfContractMP"
              label={'Datum ugovora MP'}
              onChange={onDateChange}
              value={state.dateOfContractMP}
              placement={'bottom'}
            />
            <KeybordDatePicker
              id="dateOfContractPH"
              name="dateOfContractPH"
              label={'Datum ugovora PH'}
              onChange={onDateChange}
              value={state.dateOfContractPH}
              placement={'bottom'}
            />
            <KeybordDatePicker
              id="dateOfContractEP"
              name="dateOfContractEP"
              label={'Datum ugovora EP'}
              onChange={onDateChange}
              value={state.dateOfContractEP}
              placement={'bottom'}
            />
            <InputField
              id="authorOrigin"
              name="authorOrigin"
              placeholder={'Poreklo autora'}
              value={'Domaći'}
              readOnly
            />
            <CustomSelect
              id={'residentStatus'}
              name={'residentStatus'}
              label={'Rezidentni status'}
              data={residentStatusData}
              textExtractor={(a) => a?.name}
              valueExtractor={(a) => a?.value}
              value={state.residentStatus}
              onChange={onChange}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default SecondSection;
